/**
 * author: Ananthapadmanabhan V K
 */
import React, { useEffect, useState } from 'react';
import './Subscriptions.scss';
import { withTranslation } from 'react-i18next';
import { Badge, Button, Form, Modal, OverlayTrigger, Table } from 'react-bootstrap';
import { BiDownload, BiMenuAltRight, BiPencil, BiSearch, BiShareAlt, BiPlus } from 'react-icons/bi';
import { FcFinePrint } from "react-icons/fc";
import { Link } from 'react-router-dom';
import Pagination from "../../../components/Pagination/Pagination";
import { DEFAULT_ITEMS_PER_PAGE, LIST_DEF_SORT, LS_AUTHORITY_KEY, SORT_ORDER_DESC, USER_ROLE } from '../../../core/constants/common';
import nodataimg from '../../../images/nodatafound.png'
import Utils from '../../../core/utilities/Utils';
import { toast } from "react-toastify";
import SadminSubscriptionService from '../../../core/service/SadminSubscriptionService';
import ErrorHandlingService from '../../../core/service/ErrorHandlingService';
import Multiselect from 'multiselect-react-dropdown';

const Subscriptions = ({ t }) => {
  const [key, setKey] = useState("");
  const [maintabledata, setMainTableData] = useState([]);
  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [regulations, setRegulations] = useState([]);
  const [regulationsubmitarray, setRegulationSubmitArray] = useState("");
  const [planname, setPlanName] = useState(null);
  const [numberofuser, setNumberOfUser] = useState(null);
  const [editstatusvalue, setEditStatusvalue] = useState(true);
  const [show, setShow] = useState(false);
  const [editid, setEditId] = useState(null);

  let lsData = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));

  useEffect(() => {
    getRegulations();
    getMainTableList(0, itemsPerPage, key);
  }, []);

  const getRegulations = async (e) => {
    SadminSubscriptionService.getRegulations(lsData.roles.includes(USER_ROLE.SUPER_ADMIN))
      .then((response) => {
        var resRegulations = response.data;
        setRegulations([...resRegulations]);
      })
      .catch((error) => {
      });
  };
  const getMainTableList = (pageNumber, itemsPerPageVal, key) => {
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    if (itemsPerPageVal > 0) {
      var perPage = itemsPerPageVal;
    } else {
      var perPage = itemsPerPage;
    }

    // var sort = sortField + "," + order;
    SadminSubscriptionService.getList(pageNumber, perPage, key)
      .then((response) => {
        var totalPages = parseFloat(response.headers["x-total-count"]);
        setItemTotalCount(totalPages);
        setMainTableData([...response.data]);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
        console.log("err", error);
      });
  };

  const editData = (item) => {
    setEditId(item.id);
    setPlanName(item.name);
    setNumberOfUser(item.numberOfUsers);
    setEditStatusvalue(item.active);
    setRegulationSubmitArray(item.regulations)
    handleShow();
  }

  const handleClose = () => {
    setEditId(null);
    setPlanName(null);
    setNumberOfUser(null);
    setEditStatusvalue(true);
    setShow(false);
  }
  const handleShow = () => setShow(true);

  const handleSubmit = async (e) => {
    var body = {
      name: planname,
      active: editstatusvalue,
      sortOrder: 200,
      numberOfUsers: numberofuser,
      regulations: regulationsubmitarray
    }
    if (editid) {
      body['id'] = editid;
    }
    console.log('submit------------', body);
    // return
    SadminSubscriptionService.onSubmit(editid, body)
      .then((response) => {
        console.log('response', response)
        if (response.status === 200 || response.status === 201) {
          toast.success('Success', {
            position: toast.POSITION.TOP_RIGHT,
          });
          handleClose();
          getMainTableList(0, itemsPerPage, key);
        }
      })
      .catch((error) => {
        console.log('error', error);
        //ErrorHandlingService.handleError(error.response.status);
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });

  }

  const onSelectRegulation = (selectedList, selectedItem) => {
    var array = arrayFormatter(selectedList);
    setRegulationSubmitArray([...array]);
  }

  const onRemoveRegulation = (selectedList, removedItem) => {
    var array = arrayFormatter(selectedList);
    setRegulationSubmitArray([...array])

  }

  const arrayFormatter = (selectedList) => {
    var array = [];
    for (let i = 0; i < selectedList.length; i++) {
      var obj = {
        id: selectedList[i].id
      }
      array.push(obj)
    }
    return array;
  }
  const handleSearch = (e) => {
    // var searchKey = e.target.value;
    // setKey(searchKey);
    // getMainTableList(0, itemsPerPage, searchKey);
  };
  return (
    <div className="Subscriptions">
      <div className="List_header">
        <h5 className="MH">{t("SubscriptionPlan.label")}</h5>
        <div className="List_sorts_menu">
          <ul>
            <li>
              <Button variant="secondary">
                <BiDownload /> {t("Import.label")}
              </Button>
            </li>
            <li>
              <Button variant="primary" onClick={handleShow}>
                <BiPlus />
                {t("New.label")}
              </Button>
            </li>
          </ul>
        </div>
      </div>



      <div className="List_Table_01">
        <div className="List_table-card01_head">
          <div className="List_table-card_Search_01">
            <div className="List_table-card_Search_Box">
              <Form>
                <input
                  type="text"
                  className="form-control"
                  value={key}
                  onChange={handleSearch}
                />
                <Link to="#" className="Search_iocnBox">
                  <BiSearch />
                </Link>
              </Form>
            </div>
          </div>
          <div className="List_table-card01_sort">
            <ul>
              <li>
                <a href='#'><BiShareAlt /> {t("Share.label")}</a>
              </li>
              <li>
                <a href='#'><BiMenuAltRight /> {t("Sort.label")}</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="card List_table-card01">
          <Table responsive="sm">
            <thead>
              <tr>
                <th>{t("SubscriptionPlan.label")}</th>
                <th>{t("NumberOfUsers.label")}</th>
                <th>{t("Status.label")}</th>
                <th>{t("Regulation.label")}</th>
                <th>{t("Action.label")}</th>
              </tr>
            </thead>
            {(maintabledata === undefined || maintabledata == null || maintabledata.length === 0) &&
              <tbody>
                <tr>
                  <td colSpan="7" className="text-center">
                    <div className="Nodatafound_box">
                      <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                    </div>
                  </td>
                </tr>
              </tbody>
            }
            {maintabledata && maintabledata !== undefined && maintabledata.length > 0 &&
              <tbody>
                {maintabledata?.map((item) => (
                  <tr key={item.id}>
                    <td>{item.name}</td>
                    <td>{item.numberOfUsers}</td>
                    <td>
                      <div>
                        {item.active
                          ? <Badge bg="badge-Active">
                            {t("Active.label")}
                          </Badge>
                          : <Badge bg="badge-Inactive">
                            {t("Inactive.label")}
                          </Badge>
                        }
                      </div>
                    </td>
                    <td>
                      {item?.regulations?.map((reg, i) => (
                        (i === item.regulations.length - 1)
                          ? <span>{reg.name}</span>
                          : <span>{reg.name} ,</span>
                      ))
                      }
                    </td>
                    <td>
                      <div>
                        <OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("Edit.label"))}>
                          <span><BiPencil className='cursor' onClick={() => editData(item)} /></span>
                        </OverlayTrigger>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            }
          </Table>
          <div className="p-2 List_footer_count">
            <Pagination
              itemsTotalCount={itemsTotalCount}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              alwaysShown={true}
              setItemsPerPage={setItemsPerPage}
              pageClicked={(pageNum, perPage) => {
                getMainTableList(pageNum, perPage, key);
              }}
            />
          </div>
        </div>
      </div>

      <Modal show={show}
        onHide={handleClose}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header closeButton>
          < Modal.Title as="h5">Add Subscription Plan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="Single_RC_01">
              <div className="Single_RC_Row01 m-0">
                <div className="p-2">
                  <label className="mb-1">{t("SubscriptionPlan.label")} <span className='text-red'>*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    value={planname}
                    required
                    onChange={(e) => setPlanName(e.target.value)}
                  />
                </div>
                <div className="p-2">
                  <label className="mb-1">{t("Regulation.label")} <span className='text-red'>*</span></label>
                  <Multiselect
                    options={regulations}
                    selectedValues={regulationsubmitarray}
                    onSelect={onSelectRegulation}
                    onRemove={onRemoveRegulation}
                    displayValue="name"
                  />
                </div>

                <div className="p-2">
                  <label className="mb-1">{t("NumberOfUsers.label")} <span className='text-red'>*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    value={numberofuser}
                    required
                    onChange={(e) => setNumberOfUser(e.target.value)}
                  />
                </div>
                <div className="p-2">
                  <label className="mb-1">{t("Status.label")} <span className='text-red'>*</span></label>
                  <select className="form-select" value={editstatusvalue} onChange={(e) => setEditStatusvalue(e.target.value)}>
                    <option value={true}>{t("Active.label")}</option>
                    <option value={false}>{t("Inactive.label")}</option>
                  </select>
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("Cancel.label")}
          </Button>
          <Button variant="primary" onClick={handleSubmit} className="sbmBtn">
            {t("Create.label")}
          </Button>

        </Modal.Footer>
      </Modal>
    </div>
  )
};


export default withTranslation()(Subscriptions);
